var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyNurse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#FEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3068_21510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8188 56.5034C33.6844 57.2634 34.578 58.0476 35.4972 58.8606C35.5035 58.8661 35.5099 58.8718 35.5163 58.8773L38.5741 61.5186C38.9838 61.8726 39.4923 62.0495 40.0007 62.0495C40.5092 62.0495 41.0178 61.8724 41.4275 61.5186L44.4848 58.8773C44.4912 58.8718 44.4974 58.8662 44.5037 58.8607C50.5569 53.5074 55.0954 49.4091 58.3788 45.412C62.2139 40.7436 64.0001 36.5226 64.0001 32.1283C64.0001 24.1781 57.7726 17.9506 49.8227 17.9506C46.2495 17.9506 42.719 19.296 40.0007 21.6283C37.2817 19.2959 33.7512 17.9506 30.1779 17.9506C22.2277 17.9504 16 24.1781 16 32.1282C16 41.7383 22.6909 47.6122 32.8188 56.5034ZM31.2708 35.6356H37.0901V29.816H42.9097V35.6356H48.7292V41.455H42.9097V47.2743H37.0901V41.455H31.2708V35.6356Z",
    fill: "#E95454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3068_21510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyNurse1);
export default __webpack_public_path__ + "static/media/whyNurse1.70802766e431a38adc5c8f7297cae43d.svg";
export { ForwardRef as ReactComponent };